import React from 'react';

import ShelfTypeShow from '@shared/shelf_types/ShelfTypeShow';
import { useLoaderData } from 'react-router-dom';

import shelfTypeService from '@services/operator/shelfTypeService';

export default function OperatorShelfTypeShow() {
  const shelfType = useLoaderData();

  return (
    <ShelfTypeShow
      shelfType={shelfType}
      shelfTypeService={shelfTypeService}
    />
  );
}
